import { Box, Button, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { variants } from '../../../variants/variants';
import ProfileList from './ProfileList';
import TeamList from './TeamList';
import ComingSoon from '../../WebView/components/CommingSoon';
import GroupList from './GroupList';

const ChatTabs = () => {
  const theme = useTheme();
  const [current, setCurrent] = useState(1);
  const componentMap = {
    1: <ProfileList />,
    2: <TeamList />,
    3: <GroupList />,
  };
  const activeStyle = {
    background: variants.primary,
    color: 'white',
  };
  const inactiveStyle = {
    background: 'transparent',
  };
  const handleClick = (val) => {
    setCurrent(val);
  };
  return (
    <Stack sx={{ flex: 1 }}>
      <Stack
        direction={'row'}
        alignItems={'center'}
        sx={{
          mb: 1,
          p: 0.5,
          border: 1,
          width: '100%',
          borderColor: 'divider',
          borderRadius: '20px',
          background: variants.boxBackground.PROFILE_CARD,
          justifyContent: 'space-between',
          //flex:1,
        }}
      >
        <Box
          onClick={() => handleClick(1)}
          sx={{
            ...(current === 1 ? activeStyle : inactiveStyle),
            cursor: 'default',
            borderRadius: '20px',
            px: 3,
            py: 0.5,
          }}
        >
          <Typography variant='subtitle2'>All</Typography>
        </Box>
        <Box
          onClick={() => handleClick(2)}
          sx={{
            ...(current === 2 ? activeStyle : inactiveStyle),
            cursor: 'default',
            borderRadius: '20px',
            // ml: 2,
            px: 3,
            py: 0.5,
          }}
        >
          <Typography variant='subtitle2'>My Team</Typography>
        </Box>
        <Tooltip title='Coming Soon'>
          <Box
            onClick={() => handleClick(3)}
            sx={{
              // color:'grey',
              ...(current === 3 ? activeStyle : inactiveStyle),
              cursor: 'default',
              borderRadius: '20px',
              // ml: 2,
              px: 3,
              py: 0.5,
            }}
          >
            <Typography variant='subtitle2'>Groups</Typography>
          </Box>
        </Tooltip>
      </Stack>
      {componentMap[current]}
    </Stack>
  );
};

export default ChatTabs;
